<script lang="ts" context="module">
	import NewsletterCard from "$lib/components/newsletters/NewsletterCard.svelte";
	import { getIsInsideConnect } from "../currentUser";
</script>

<script lang="ts">
	export let newsletters: any[];
	export let hideOverlay = false;

	const isInsideConnect = getIsInsideConnect();
</script>

<div
	class="grid w-full grid-cols-1 gap-[var(--gap,theme(gap.6))] overflow-clip @[500px]:grid-cols-2 @[600px]:grid-cols-3 lg:grid-cols-3"
	class:xl:grid-cols-[repeat(auto-fit,minmax(226px,269px))]={isInsideConnect}>
	<slot />
	{#each newsletters as newsletter, i (newsletter.id)}
		{#key newsletter.id}
			<NewsletterCard bind:newsletter {hideOverlay} />
		{/key}
	{/each}
</div>
